import React from 'react'

import ProjectCarouselButtons from '../ProjectCarouselButtons'

const FacialRecognition = () => {
    return (
        <>
            <div className="Project--split--window">
                <div className="Project-Carousel-info-container">
                    <div id="carouselExampleIndicatorsFacialRecognition" className="carousel slide Project-Carousel-container">

                        <div className="carousel-inner">
                            <div className="carousel-item active">
                            <video controls="controls" className="d-block w-100">
                                    <source src="../IMG/FacialRecognition/Facial Recognition.mp4" type="video/mp4" />
                                </video>
                            </div>
                        </div>

                        <ProjectCarouselButtons tag="FacialRecognition" />

                    </div>

                    <div className="Project-info-container">
                        <div className="Project--info--Para-container">
                            <p className="Project--info--heading">Facial Recognition</p>
                            <p className="Project--info--subheading">Real-Time Facial Recognition and Emotion Detection</p>
                            <p className="Project--info--subheading">ML/AI Development</p>
                            <p className="Project--info--Para">This project is a real-time facial recognition and emotion detection system. It focuses on identifying faces and predicting emotional states, offering valuable insights for various applications such as sentiment analysis, surveillance, and interactive systems.</p>
                            <p className="Project--info--Para">Real-time facial detection with emotion, age, and gender prediction, offering dynamic on-screen feedback using deep learning models.</p>
                        </div>
                        <div className="Project--info--links">
                            <a href="https://github.com/Chauhan-Aman/Facial-Recognition" target='__blank'>Github</a>
                        </div>
                        <div className="Project--info--tech">
                            <p>Computer Vision</p>
                            <p>JavaScript</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default FacialRecognition